// local API call base URL "http://localhost:7000/api/v1"
// staging API call base URL "https://api.auradine.gold/v1/customer"


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const MUI_LICENSE_KEY =
//   "6786996b2ab638cc3a4211570da06e30Tz05ODU0MSxFPTE3NTg0NzY2ODIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg==";
const MUI_LICENSE_KEY =
     "396f33e551bceae6781b7c768ce92077Tz0xMTk2MDMsRT0xNzkwMzgwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=";

const env = {
  REACT_APP_AUTH0_DOMAIN:
    process.env.REACT_APP_AUTH0_DOMAIN,
  REACT_APP_AUTH0_CLIENT_ID:
    process.env.REACT_APP_AUTH0_CLIENT_ID,
  REACT_APP_AUDIENCE: process.env.REACT_APP_AUDIENCE,
  REACT_FLUX_VISION: process.env.REACT_FLUX_VISION,
  MUI_LICENSE_KEY: MUI_LICENSE_KEY,

  APIPath: {
    jobs: API_BASE_URL + "/jobs",
    jobsBySerial: API_BASE_URL + "/jobsBySerial",
    jobsBySerialCS: API_BASE_URL + "/jobsBySerialCS",
    jobdetailsbyid: API_BASE_URL + "/jobdetailsbyid",
    jobinfobyid: API_BASE_URL + "/jobinfobyid",
    jobDetailsByIdCount:
      API_BASE_URL + "/jobdetailsbyidcount",
    user: API_BASE_URL + "/user",
    theme: API_BASE_URL + "/theme",
    userWithSubscription:
      API_BASE_URL + "/userWithSubscription",
    addFilterList: API_BASE_URL + "/addFilterList",
    deleteFilterList: API_BASE_URL + "/deleteFilterList",
    filterListNames: API_BASE_URL + "/filterListNames",
    getFilterList: API_BASE_URL + "/filterListByName",
    addCaseFilterList: API_BASE_URL + "/addCaseFilterList",
    deleteCaseFilterList: API_BASE_URL + "/deleteCaseFilterList",
    casefilterListNames: API_BASE_URL + "/casefilterListNames",
    getCaseFilterList: API_BASE_URL + "/casefilterListByName",
    userNew: API_BASE_URL + "/usernew",
    transfer: API_BASE_URL + "/transfer",
    acceptTransfer: API_BASE_URL + "/acceptTransfer",
    rejectTransfer: API_BASE_URL + "/rejectTransfer",
    minerRemoveOperation:
      API_BASE_URL + "/minerRemoveOperation",
    deleteSiteOrGroup: API_BASE_URL + "/deleteSiteOrGroup",
    getAlerts: API_BASE_URL + "/alertSubscriptions",
    setAlertNotifications:
      API_BASE_URL + "/alertNotificationConfigAtUser",
    setAlertConfig:
      API_BASE_URL + "/alertNotificationConfigAtOrg",
    PostPermissions: API_BASE_URL + "/permissions",
    userAPINew: API_BASE_URL + "/userAPINew",
    getUserAPIKey: API_BASE_URL + "/getNewAPIKey",
    preference: API_BASE_URL + "/preference",
    preferenceNew: API_BASE_URL + "/preferenceNew",
    preferenceNewCS: API_BASE_URL + "/preferenceNewCS",
    getmaxlimits: API_BASE_URL + "/getmaxlimits",
    handleAPIKey: API_BASE_URL + "/handleAPIKey",
    listCBSNs: API_BASE_URL + "/listCBSNs",
    listChassisSerialNumbers:
      API_BASE_URL + "/listChassisSerialNumbers",
    listMacs: API_BASE_URL + "/listMacs",
    listCaseNumbers: API_BASE_URL + "/listCaseNumbers",
    listCaseIssues: API_BASE_URL + "/listCaseIssues",
    listCaseCreatedBy: API_BASE_URL + "/listCaseCreatedBy",
    listCaseSerialNo: API_BASE_URL + "/listCaseSerialNo",
    listCaseUpdatedBy: API_BASE_URL + "/listCaseUpdatedBy",
    caseCommands: API_BASE_URL + "/caseCommands",
    getCaseCommentHistory: API_BASE_URL + "/getCaseCommentHistory",
    listGCMinerVersions:
      API_BASE_URL + "/listGCMinerVersions",
    siteLists: API_BASE_URL + "/siteList2.0",
    orgSiteLists: API_BASE_URL + "/orgsitelist",
    updateSiteLocation: API_BASE_URL + "/updateSiteLocation",
    activeCurtailmentSites:
      API_BASE_URL + "/activeCurtailScheduleForOrg",
    tagList: API_BASE_URL + "/tagList",
    addTag: API_BASE_URL + "/addTag",
    deleteTag: API_BASE_URL + "/deleteTag",
    attachTagsToMiners:
      API_BASE_URL + "/attachTagsToMiners",
    tagListFromMiners: API_BASE_URL + "/tagListFromMiners",
    detachTagsFromMiners:
      API_BASE_URL + "/detachMultiTagsFromMultiMiners",
    postacceptedpools: API_BASE_URL + "/postacceptedpools",
    postdeleteacceptedpools:
      API_BASE_URL + "/postdeleteacceptedpools",
    usertechsupport: API_BASE_URL + "/usertechsupport",
    usertechsupportfilter:
      API_BASE_URL + "/usertechsupportfilter",
    invite: API_BASE_URL + "/invite",
    domains: API_BASE_URL + "/domains",
    org: API_BASE_URL + "/org",
    getOrg: API_BASE_URL + "/getOrg",
    orgtechsupport: API_BASE_URL + "/orgtechsupport",
    getdgorgconfig: API_BASE_URL + "/getdgorgconfig",
    getdgorgconfigV2: API_BASE_URL + "/getdgorgconfigV2",
    getsiteorgconfig: API_BASE_URL + "/getsiteorgconfig",
    postdgorgconfig: API_BASE_URL + "/postdgorgconfig",
    postdgorgconfigV2: API_BASE_URL + "/postdgorgconfigV2",
    postsiteorgconfig: API_BASE_URL + "/postsiteorgconfig",
    postmultidgorgconfig:
      API_BASE_URL + "/postmultidgorgconfig",
    postmultidgorgconfigV2:
      API_BASE_URL + "/postmultidgorgconfigV2",
    postmultisiteorgconfig:
      API_BASE_URL + "/postmultisiteorgconfig",
    otheruser: API_BASE_URL + "/otheruser",
    device: API_BASE_URL + "/device",
    deviceNew: API_BASE_URL + "/deviceNew",
    deviceNewCS: API_BASE_URL + "/deviceNewCS",
    chipStats: API_BASE_URL + "/chipstats",
    chipStatsCS: API_BASE_URL + "/chipstatsCS",
    deviceOperation: API_BASE_URL + "/deviceOperation",
    updateRunTimeDB: API_BASE_URL + "/updateRunTimeDB",
    privacy: API_BASE_URL + "/privacy",
    summary: API_BASE_URL + "/summary",
    summaryCS: API_BASE_URL + "/summaryCS",
    summaryLED: API_BASE_URL + "/summaryLED",
    summaryLEDCS: API_BASE_URL + "/summaryLEDCS",
    getCurrentTHsPowerForDashboard: API_BASE_URL + "/getCurrentTHsPowerForDashboard",
    getIssuesCountForDashboard: API_BASE_URL + "/getIssuesCountForDashboard",
    getIssuesCountForDashboardCS: API_BASE_URL + "/getIssuesCountForDashboardCS",
    siteTemperatures: API_BASE_URL + "/siteTemperatures",
    cloudcommand: API_BASE_URL + "/commands",
    groupcommands: API_BASE_URL + "/groupcommands",
    sitecommands: API_BASE_URL + "/sitecommands",
    alertNotificationConfig:
      API_BASE_URL + "/alertNotificationConfig",
    checkdatabase: API_BASE_URL + "/cmdrespserials",
    validcommands: API_BASE_URL + "/validcmds",
    devicelist: API_BASE_URL + "/devicelist",
    dglist: API_BASE_URL + "/dglist",
    export: API_BASE_URL + "/export",
    exportCases: API_BASE_URL + "/exportCases",
    isOperationAllowed:
      API_BASE_URL + "/isOperationAllowed",
    isPoolOperationAllowed:
      API_BASE_URL + "/isPoolOperationAllowed",
    dgdevices: API_BASE_URL + "/getdgdevices",
    orgdevices: API_BASE_URL + "/getorgdevices",
    dgconfig: API_BASE_URL + "/dgconfig",
    siteconfig: API_BASE_URL + "/siteconfig",
    multidgconfig: API_BASE_URL + "/multidgconfig",
    multisiteconfig: API_BASE_URL + "/multisiteconfig",
    dgtgtTHs: API_BASE_URL + "/dgtgtTHs",
    dgoptTHs: API_BASE_URL + "/dgoptTHs",
    dgtgtPower: API_BASE_URL + "/dgtgtPower",
    dgautoTemparture: API_BASE_URL + "/dgautoTemparture",
    dgisTgtHR: API_BASE_URL + "/dgisTgtHR",
    dgramp: API_BASE_URL + "/dgramp",
    getdginfo: API_BASE_URL + "/getdginfo",
    dgview: API_BASE_URL + "/dgview",
    siteview: API_BASE_URL + "/siteview",
    dgnames: API_BASE_URL + "/dgnames",
    sitenames: API_BASE_URL + "/sitenames",
    dguseHR: API_BASE_URL + "/dguseHR",

    btc: API_BASE_URL + "/btc",
    manualEfficiencyTune:
      API_BASE_URL + "/manualEfficiencyTune",
    manualPowerCurtailSchedule:
      API_BASE_URL + "/manualPowerCurtailSchedule",
    manualPowerCurtailNow:
      API_BASE_URL + "/manualPowerCurtailNow",
    powerCurtailSchedule:
      API_BASE_URL + "/powerCurtailSchedule",
    groupCurtailData: API_BASE_URL + "/groupCurtailData",
    siteCurtailData: API_BASE_URL + "/siteCurtailData",
    autotune: API_BASE_URL + "/autotune",
    onboard: API_BASE_URL + "/onboard",
    importDevices: API_BASE_URL + "/importDevices",
    deregisterDevices: API_BASE_URL + "/deregisterDevices",
    removeOrgTechsupport:
      API_BASE_URL + "/removeOrgTechsupport",
    removeDevices: API_BASE_URL + "/removeDevices",
    addDGmember: API_BASE_URL + "/addDGmember",
    // deleteDGmember: API_BASE_URL + "/deleteDGmember",
    moveDGmember: API_BASE_URL + "/moveDGmember",
    moveSitemember: API_BASE_URL + "/moveSitemember",
    minerTechsupport: API_BASE_URL + "/minerTechsupport",
    getTSJobStatus: API_BASE_URL + "/getTSJobStatus",
    getCommandStatus: API_BASE_URL + "/getCommandStatus",
    addDG: API_BASE_URL + "/addDG",
    addDGToSite: API_BASE_URL + "/addDGToSite",

    deleteDG: API_BASE_URL + "/deleteDG",
    addSite: API_BASE_URL + "/addSite2.0",
    deleteSite: API_BASE_URL + "/deleteSite",
    addCustomNames: API_BASE_URL + "/addCustomNames",
    addCSTags: API_BASE_URL + "/addCSTags",
    autoTuneV2Config: API_BASE_URL + "/autoTuneV2Config",
    getAutoTuneV2Config:
      API_BASE_URL + "/getAutoTuneV2Config",
    getAllAutoTuneV2Config:
      API_BASE_URL + "/getAllAutoTuneV2Config",
    attachAutoTuneV2Config:
      API_BASE_URL + "/attachAutoTuneV2Config",
    getEnergyPrice: API_BASE_URL + "/getEnergyPrice",
    getHashPrice: API_BASE_URL + "/getHashPrice",
    desiredAlertIntervalCSTeam:
      API_BASE_URL + "/desiredAlertIntervalCSTeam",
    alertNotificationConfigAtUser:
      API_BASE_URL + "/alertNotificationConfigAtUser",
    alertNotificationConfigAtOrg:
      API_BASE_URL + "/alertNotificationConfigAtOrg",
    alertSubscriptions:
      API_BASE_URL + "/alertSubscriptions",
    caselist: API_BASE_URL + "/caselist",
    getIssueSummaryBreakdown: API_BASE_URL + "/getIssueSummaryBreakdown",
    getCaseStatusBreakdown: API_BASE_URL + "/getCaseStatusBreakdown",
  },
};

export { env };
